module.exports = __webpack_public_path__ + "img/footer-equal-housing.363e17e1.svg";